import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import {
    SprayEventPostRequestPayload,
    SprayEventPatchRequestPayload,
    SprayEventUuid
} from 'services/sprayEvents/types';
import { AppState } from 'services/types';

// Global Actions
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import {
    requestCreateSprayEvent,
    requestUpdateSprayEvent
} from 'services/sprayEvents/actions';

// Local Components
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';
import { formatSprayEventPayloads } from 'services/sprayEvents/utils';
import SprayEventForm, {
    SPRAY_EVENT_UPDATE,
    SPRAY_EVENT_CREATE
} from './components/SprayEventForm';

interface OwnProps {
    title: string;
    isEditing?: boolean;
}

interface ConnectedProps {
    sprayEventUuid?: SprayEventUuid;
    isWeedSpray: ReturnType<typeof selectSprayEventTypeIsWeed>;
}
interface DispatchProps {
    requestCreateSprayEvent: (values: SprayEventPostRequestPayload) => any;
    requestUpdateSprayEvent: (values: SprayEventPatchRequestPayload) => any;
}

type Props = ConnectedProps & DispatchProps & OwnProps;

export class SprayEventFinalForm extends React.PureComponent<Props> {
    handleSubmit = (values: SprayEventPostRequestPayload): void => {
        let { sprayProducts } = values;
        const { startDate } = values;
        const {
            sprayEventUuid,
            isEditing,
            isWeedSpray,
            requestUpdateSprayEvent: requestUpdateSprayEventAction,
            requestCreateSprayEvent: requestCreateSprayEventAction
        } = this.props;

        sprayProducts = sprayProducts.map(
            ({ id, units, perUnitType }, index) => ({
                id,
                units,
                perUnitType,
                orderIndex: index + 1
            })
        );

        if (isEditing && sprayEventUuid) {
            requestUpdateSprayEventAction(
                formatSprayEventPayloads({
                    sprayEventUuid,
                    ...values,
                    sprayProducts,
                    endDate: startDate,
                    isWeedSpray
                }) as SprayEventPatchRequestPayload
            );
        } else {
            requestCreateSprayEventAction(
                formatSprayEventPayloads({
                    ...values,
                    sprayProducts,
                    endDate: startDate,
                    isWeedSpray
                })
            );
        }
    };

    render(): React.ReactElement {
        const { sprayEventUuid, isEditing, title } = this.props;
        const namespace = isEditing ? SPRAY_EVENT_UPDATE : SPRAY_EVENT_CREATE;

        return (
            <SprayEventForm
                handleSubmit={this.handleSubmit}
                sprayEventUuid={sprayEventUuid}
                namespace={namespace}
                isEditing={isEditing}
                title={title}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    sprayEventUuid: makeSelectQueryStringValue('sprayEventUuid'),
    isWeedSpray: selectSprayEventTypeIsWeed
});

export default connect(mapStateToProps, {
    requestCreateSprayEvent,
    requestUpdateSprayEvent
})(SprayEventFinalForm);
